import {useEffect, useState} from "react";
import '../Styles/CreateGroupReview.scss'
import { Link } from "react-router-dom";
import {Helmet} from "react-helmet";
import DateHelpers from '../Helper/DateHelpers.js';
import React from "react";



function CreateGroupReview()
{
   

   const [existingInformation, setExistingInformation] = useState({
      groupID: '',
      groupName: '',
      groupAddress1: '',
      groupAddress2: '',
      groupCity: '',
      groupState: '',
      groupZip: '',
      groupCountry: '',
      groupEmail: '',
      groupAdmin: '',
      groupWeek: '',
   });
   const getUpdateInformation = async () => {
      try {

         const response2 = await fetch('/api/get-user', {
            method: 'GET',
            headers: { "Content-Type": "application/json" }
         })
         const account = await response2.json();
         
         const response = await fetch('/getgroupinformation', {
            method: 'POST',
            headers: { "Content-Type": "application/json" },
            body: JSON.stringify(
               {
                  email: account.user.email
               }
            )
         })
   
         // This will be updated with UseEffect                       // 
         const groupJSON = await response.json();
         const groupData = groupJSON.data[0]; 
         // Here is the info that is returning!
         console.log(groupData)

         setExistingInformation({...existingInformation, 
            groupID: groupData.group_id,
            groupName: groupData.group_name, 
            groupAddress1: groupData.group_address1,
            groupAddress2: groupData.group_address2,
            groupCity: groupData.group_city,
            groupState: groupData.group_state,
            groupZip: groupData.group_zip,
            groupCountry: groupData.group_country,
            groupEmail: groupData.group_email,
            groupAdmin: groupData.church_group_admin, 
            groupWeek: groupData.church_camp_week,
            }) 

            console.log("existingInformation",existingInformation)
         }
     
      catch (error) {
         console.error(error.message); 
         }
   };

   useEffect (() => { 
      getUpdateInformation();
     }, []);

   return(
      <div className="createGroupReviewContent">
         <div className="createGroupReviewContainer">
            <table className="createGroupReviewTable">
               <tr>
                  <h1>Review Account Information*</h1>
               </tr>
               <tr>
                  <th>Group ID</th>
                  <td>{existingInformation.groupID}</td>
               </tr>
               <tr>
                  <th>Group Email</th>
                  <td>{existingInformation.groupEmail}</td>
               </tr>
               <tr>
                  <th>Group Name</th>
                  <td>{existingInformation.groupName}</td>
               </tr>
               <tr>
                  <th>Group Address</th>
                  <td>{existingInformation.groupAddress1}</td>
               </tr>
               <tr>
                  <th>Group City</th>
                  <td>{existingInformation.groupCity}</td>
               </tr>
               <tr>
                  <th>Group State</th>
                  <td>{existingInformation.groupState}</td>
               </tr>
               <tr>
                  <th>Group Zip</th>
                  <td>{existingInformation.groupZip}</td>
               </tr>
               <tr>
                  <th>Group Country</th>
                  <td>{existingInformation.groupCountry}</td>
               </tr>
               <tr>
                  <th>Group Administrator</th>
                  <td>{existingInformation.groupAdmin}</td>
               </tr>
               
            </table>
            <div className="createGroupReviewPageHr">
               <hr></hr>
            </div>
            <div className="createGroupReviewbuttonbox">
               <Link  to={'/groupaccount'}>
                  <button>
                        Confirm Group Information
                  </button>
               </Link>
            </div>
            <div className="fakeDataDisclaimer">
            * If you wish to update account information, please contact the Ranch.
            </div>
         </div>
      </div>
   )
}

export default CreateGroupReview; 
